import "./src/styles/resets.css"
import "./src/styles/globals.css"
import "./src/styles/navbar.css"
import "./src/styles/fonts.css"
import { initializePixel, pageView } from './src/utils/metaPixel';

// Initialize Meta Pixel
export const onClientEntry = () => {
  initializePixel();
};

// Track page views on route changes
export const onRouteUpdate = () => {
  pageView();
};
